{
  "chart": {
    "header": "Chart",
    "linkedDocumentsOutsideCategory": "Linked documents outside of this category",
    "hideCategories": "Hide categories",
    "groupByGraphs": "Group by graphs",
    "includeDrafts": "Include non published documents"
  }
}
